export const ns = "SortScreen"

export default {
  [ns]: {
    check: "Valider",
  },
}
